import { apiRequest } from './client.js';
import type { Device } from '@hisob/types';
import type { CursorPaginatedResult } from '../types/index.js';

export async function fetchDevices(params?: {
  limit?: number;
  cursor?: string;
  platform?: string;
  search?: string;
}): Promise<CursorPaginatedResult<Device>> {
  return apiRequest<CursorPaginatedResult<Device>>('/api/v1/admin/devices', { params });
}

export async function fetchDeviceById(deviceId: string): Promise<Device> {
  return apiRequest<Device>(`/api/v1/admin/devices/${deviceId}`);
}

export async function revokeDevice(deviceId: string): Promise<{ success: boolean; revoked_at: number }> {
  return apiRequest<{ success: boolean; revoked_at: number }>(`/api/v1/admin/devices/${deviceId}/revoke`, {
    method: 'POST',
  });
}

